import regularTsv from '../../../localization/regular-translation-changes.tsv?raw';
import lines40Tsv from '../../../localization/40-lines-translation-changes.tsv?raw';
import lines100Tsv from '../../../localization/100-lines-translation-changes.tsv?raw';

/**
 * Copy owned by the client, not the translation service.
 * Regular intro, plus the 40-line and 100-line title and intro.
 */
export const LOCAL_LINE_COPY_KEYS = [
  'INFO_INTRO_BODY',
  '40_GAME_TITLE',
  '40_INFO_INTRO_BODY',
  '100_GAME_TITLE',
  '100_INFO_INTRO_BODY',
];

/**
 * @param {string} raw
 * @returns {Record<string, Record<string, string>>}
 */
function parseLocaleTsv(raw) {
  const lines = String(raw ?? '')
    .replace(/^\uFEFF/, '')
    .trim()
    .split(/\r?\n/)
    .filter((line) => line.trim().length > 0);
  if (lines.length < 2) return {};
  const locales = lines[0].split('\t').slice(1).map((locale) => locale.trim().toLowerCase());
  /** @type {Record<string, Record<string, string>>} */
  const out = {};
  for (const line of lines.slice(1)) {
    const cols = line.split('\t');
    const key = cols[0]?.trim();
    if (!key) continue;
    /** @type {Record<string, string>} */
    const byLocale = {};
    locales.forEach((locale, index) => {
      if (!locale) return;
      byLocale[locale] = cols[index + 1] ?? '';
    });
    out[key] = byLocale;
  }
  return out;
}

/** @type {Record<string, Record<string, string>>} */
const LOCAL_LINE_COPY = {
  ...parseLocaleTsv(regularTsv),
  ...parseLocaleTsv(lines40Tsv),
  ...parseLocaleTsv(lines100Tsv),
};

/**
 * @param {string | null | undefined} culture
 * @returns {string}
 */
export function lineCopyLocale(culture) {
  const primary = String(culture ?? 'en')
    .trim()
    .toLowerCase()
    .replace(/_/g, '-')
    .split('-')[0];
  if (primary && LOCAL_LINE_COPY.INFO_INTRO_BODY?.[primary]) return primary;
  return 'en';
}

/**
 * Client-owned string for one of {@link LOCAL_LINE_COPY_KEYS}.
 * @param {string} key
 * @param {string | null | undefined} culture
 * @returns {string | undefined}
 */
export function localLineCopy(key, culture) {
  const row = LOCAL_LINE_COPY[key];
  if (!row) return undefined;
  const locale = lineCopyLocale(culture);
  const value = row[locale] || row.en;
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}
